import React, {Component, Fragment } from 'react';
import watch from '../../../images/driverpolicy-images/Watch.png';

class LateReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
    return(

      <Fragment>
      	<span id='latereturn' className='anchor2'></span>
         <div className='late__content--container'>
            <span className='damages__title--container'>
              <img src={watch}/>
              <h3><strong>Late Return</strong></h3>
            </span>
            <br/>
         	<div className='late__intro--container'> 
			    <p>
			      Everyone has a grace period of 15 minutes after the end time of a booking to return the car without penalty. 
			    </p>
			    <p>
			      If you are waiting for a car that has not returned yet, please report through the Autzu Dashboard and call our 24/7 Support line at 1-833-692-8898 so we can try to change you into another car. 
			    </p>
			    <p>
			      If no other cars are available, the previous driver will be charged a fee and an amount will be credited to you as the waiting driver.
			    </p>
		    </div>
		    <br/>
				<div className="faq__column--container">
					<table className="faq__table">
						<thead>
							<th className="faq__table__th">Late Driver Fee</th>
							<th className="faq__table__th">Waiting Driver Credit</th>
						</thead>
						<tbody>
							<tr>
								<td className="faq__table__td">0-15 min: grace period (no fee)</td>
								<td className="faq__table__td">0-15 min: grace period (no credit)</td>
							</tr>
							<tr>
								<td className="faq__table__td">16-30 min: $15</td>
								<td className="faq__table__td">16-30 min: $10</td>
							</tr>
							<tr>
								<td className="faq__table__td">31-60 min: $30</td>
								<td className="faq__table__td">31-60 min: $20</td>
							</tr>
							<tr>
								<td className="faq__table__td">61-90 min: $45</td>
								<td className="faq__table__td">61-90 min: $30</td>
							</tr>
							<tr>
								<td className="faq__table__td">91-120 min: $60</td>
								<td className="faq__table__td">91-120 min: $40</td>
							</tr>
						</tbody>
					</table>
				</div>
				<br/>
				<br/>
	    </div>
      </Fragment>

    )
  }
 }

export default LateReturn;


// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/LateReturn.js